/**
 * Media Carousel Component
 */
(function () {
  "use strict";

  const MediaCarousel = {
    init() {
      const carousels = document.querySelectorAll("[data-media-carousel]");
      carousels.forEach((carousel) => this.initCarousel(carousel));
    },

    initCarousel(carousel) {
      const container = carousel.querySelector("[data-carousel-container]");
      const prevBtn = carousel.querySelector("[data-carousel-prev]");
      const nextBtn = carousel.querySelector("[data-carousel-next]");
      const thumbnails = carousel.querySelectorAll("[data-carousel-thumbnail]");

      if (!container) return;

      let currentIndex = 0;
      const items = container.querySelectorAll("[data-carousel-item]");
      const total = items.length;

      if (total <= 1) return;

      const goToSlide = (index, direction = "next") => {
        if (index === currentIndex) return;

        const currentItem = items[currentIndex];
        const nextItem = items[index];

        if (!currentItem || !nextItem) return;

        // Set initial positions
        nextItem.style.transform =
          direction === "next" ? "translateX(100%)" : "translateX(-100%)";
        nextItem.style.opacity = "1";
        nextItem.style.zIndex = "2";
        currentItem.style.zIndex = "1";

        // Trigger reflow
        nextItem.offsetHeight;

        // Animate
        currentItem.style.transition =
          "transform 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955)";
        nextItem.style.transition =
          "transform 0.5s cubic-bezier(0.455, 0.03, 0.515, 0.955)";

        currentItem.style.transform =
          direction === "next" ? "translateX(-100%)" : "translateX(100%)";
        nextItem.style.transform = "translateX(0)";

        setTimeout(() => {
          currentItem.style.transform = "";
          currentItem.style.opacity = "";
          currentItem.style.zIndex = "";
          nextItem.style.zIndex = "";
          currentIndex = index;
          updateThumbnails();
        }, 500);
      };

      const updateThumbnails = () => {
        thumbnails.forEach((thumb, idx) => {
          if (idx === currentIndex) {
            thumb.classList.add("border-gum");
            thumb.classList.remove("border-black");
          } else {
            thumb.classList.remove("border-gum");
            thumb.classList.add("border-black");
          }
        });
      };

      if (prevBtn) {
        prevBtn.addEventListener("click", () => {
          const newIndex = (currentIndex - 1 + total) % total;
          goToSlide(newIndex, "prev");
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener("click", () => {
          const newIndex = (currentIndex + 1) % total;
          goToSlide(newIndex, "next");
        });
      }

      thumbnails.forEach((thumb, index) => {
        thumb.addEventListener("click", () => {
          if (index !== currentIndex) {
            const direction = index > currentIndex ? "next" : "prev";
            goToSlide(index, direction);
          }
        });
      });

      updateThumbnails();
    },
  };

  window.MediaCarousel = MediaCarousel;
})();

